// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DeliveryForm_page__SFeNO {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.DeliveryForm_cardTitle__RpQMf {
  font-size: 22px;
  font-weight: 700;
  color: var(--dylo-ink);
  margin: 0 0 18px;
}

.DeliveryForm_fieldsGrid__xSx-s {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  gap: 14px 20px;
}
.DeliveryForm_schedulesGroup__qQsIl {
  grid-column: 1 / span 2;
  align-self: stretch;
  padding: 14px 16px;
  border: 1px solid var(--dylo-line);
  border-radius: 12px;
  background: color-mix(in srgb, var(--dylo-field-bg) 55%, transparent);
}
.DeliveryForm_groupLabel__8mmr3 {
  display: block;
  font-size: 13.5px;
  font-weight: 700;
  color: var(--dylo-ink);
  margin-bottom: 12px;
}
.DeliveryForm_schedulesRow__CC9jv {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
}
/* \`min(300px, 100%)\` (21-oct-2026): en un teléfono angosto la columna mínima de 300 px no cabía. En escritorio, igual. */
.DeliveryForm_checksGrid__2K081 {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(min(300px, 100%), 1fr));
  gap: 14px 24px;
  margin-top: 18px;
}
.DeliveryForm_grid4__CeQ2s {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 14px;
  margin-bottom: 14px;
}
.DeliveryForm_grid3__AEQkh {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 14px;
  margin-bottom: 14px;
}
.DeliveryForm_grid2b__GaBuS {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 14px;
}

.DeliveryForm_field__dthiS {
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 0;
}
.DeliveryForm_label__X8vS2 {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  font-weight: 600;
  color: var(--dylo-text);
}
.DeliveryForm_req__UMT6F {
  color: var(--dylo-orange);
  font-weight: 700;
}

/* Checkboxes */
.DeliveryForm_checks__-LCSj {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 4px;
}
.DeliveryForm_checkRow__tcGFB {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 13.5px;
  color: var(--dylo-ink);
  cursor: pointer;
}
.DeliveryForm_checkNative__Mxj8A {
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;
}
.DeliveryForm_checkBox__CriYS {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  flex-shrink: 0;
  border-radius: 5px;
  border: 1.5px solid var(--dylo-field-border);
  color: #fff;
  transition: background 0.14s ease, border-color 0.14s ease;
}
.DeliveryForm_checkOn__T7VWi {
  background: var(--dylo-teal-700);
  border-color: var(--dylo-teal-700);
}

.DeliveryForm_alert__dydTa {
  margin-top: 16px;
  padding: 11px 16px;
  border-radius: 12px;
  border: 1px solid color-mix(in srgb, var(--dylo-danger) 45%, transparent);
  background: color-mix(in srgb, var(--dylo-danger) 10%, transparent);
  color: var(--dylo-danger);
  font-size: 13px;
}
.DeliveryForm_savedMsg__Zbpc9 {
  margin-top: 16px;
  padding: 11px 16px;
  border-radius: 12px;
  border: 1px solid color-mix(in srgb, #2aad27 45%, transparent);
  background: color-mix(in srgb, #2aad27 10%, transparent);
  color: #2aad27;
  font-size: 13px;
  font-weight: 600;
}

.DeliveryForm_actions__-GP7T {
  display: flex;
  gap: 12px;
  margin-top: 20px;
}
.DeliveryForm_submitBtn__ttMsP {
  background: var(--dylo-orange) !important;
  border: none !important;
}
.DeliveryForm_submitBtn__ttMsP:hover:not(:disabled) {
  background: var(--dylo-orange-hover) !important;
}
.DeliveryForm_deleteBtn__26I7y {
  flex-shrink: 0;
  border: 1px solid color-mix(in srgb, var(--dylo-danger) 45%, transparent) !important;
  color: var(--dylo-danger) !important;
  background: transparent !important;
}
.DeliveryForm_deleteBtn__26I7y:hover {
  background: color-mix(in srgb, var(--dylo-danger) 12%, transparent) !important;
}
.DeliveryForm_deleteConfirm__ltxap {
  background: var(--dylo-danger) !important;
  border: none !important;
}
.DeliveryForm_confirmText__-e1he {
  font-size: 13.5px;
  color: var(--dylo-text);
  line-height: 1.5;
  margin: 0;
}
.DeliveryForm_confirmText__-e1he b {
  color: var(--dylo-ink);
}

/* Skeleton */
.DeliveryForm_skTitle__zHnnq {
  margin-bottom: 18px !important;
}
.DeliveryForm_skRounded__q\\+P9i {
  border-radius: 10px !important;
}

@media (max-width: 1000px) {
  .DeliveryForm_grid4__CeQ2s {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
@media (max-width: 560px) {
  /* \`minmax(0, 1fr)\` y no \`1fr\` (26-oct-2026): con \`1fr\` la columna no baja del ancho mínimo de un campo, que en el
     iPhone es más ancho que en Chromium, y la forma se salía de la tarjeta (lo que le pasaba al login). */
  .DeliveryForm_grid3__AEQkh,
  .DeliveryForm_grid4__CeQ2s,
  .DeliveryForm_grid2b__GaBuS,
  .DeliveryForm_schedulesRow__CC9jv {
    grid-template-columns: minmax(0, 1fr);
  }
  /* Con una sola columna, \`span 2\` creaba una segunda de sobra y los campos quedaban más angostos que el recuadro de
     horarios (21-oct-2026). */
  .DeliveryForm_schedulesGroup__qQsIl {
    grid-column: 1 / -1;
  }
}
`, "",{"version":3,"sources":["webpack://./src/v2/pages/DeliveryForm/DeliveryForm.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,cAAc;AAChB;AACA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,kCAAkC;EAClC,mBAAmB;EACnB,qEAAqE;AACvE;AACA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;AACA,yHAAyH;AACzH;EACE,aAAa;EACb,sEAAsE;EACtE,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,sBAAsB;EACtB,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,SAAS;AACX;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,4CAA4C;EAC5C,WAAW;EACX,0DAA0D;AAC5D;AACA;EACE,gCAAgC;EAChC,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,yEAAyE;EACzE,mEAAmE;EACnE,yBAAyB;EACzB,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,8DAA8D;EAC9D,wDAAwD;EACxD,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,yCAAyC;EACzC,uBAAuB;AACzB;AACA;EACE,+CAA+C;AACjD;AACA;EACE,cAAc;EACd,oFAAoF;EACpF,oCAAoC;EACpC,kCAAkC;AACpC;AACA;EACE,8EAA8E;AAChF;AACA;EACE,yCAAyC;EACzC,uBAAuB;AACzB;AACA;EACE,iBAAiB;EACjB,uBAAuB;EACvB,gBAAgB;EAChB,SAAS;AACX;AACA;EACE,sBAAsB;AACxB;;AAEA,aAAa;AACb;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;;AAEA;EACE;IACE,gDAAgD;EAClD;AACF;AACA;EACE;0GACwG;EACxG;;;;IAIE,qCAAqC;EACvC;EACA;8BAC4B;EAC5B;IACE,mBAAmB;EACrB;AACF","sourcesContent":[".page {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n.cardTitle {\n  font-size: 22px;\n  font-weight: 700;\n  color: var(--dylo-ink);\n  margin: 0 0 18px;\n}\n\n.fieldsGrid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));\n  gap: 14px 20px;\n}\n.schedulesGroup {\n  grid-column: 1 / span 2;\n  align-self: stretch;\n  padding: 14px 16px;\n  border: 1px solid var(--dylo-line);\n  border-radius: 12px;\n  background: color-mix(in srgb, var(--dylo-field-bg) 55%, transparent);\n}\n.groupLabel {\n  display: block;\n  font-size: 13.5px;\n  font-weight: 700;\n  color: var(--dylo-ink);\n  margin-bottom: 12px;\n}\n.schedulesRow {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 16px;\n}\n/* `min(300px, 100%)` (21-oct-2026): en un teléfono angosto la columna mínima de 300 px no cabía. En escritorio, igual. */\n.checksGrid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(min(300px, 100%), 1fr));\n  gap: 14px 24px;\n  margin-top: 18px;\n}\n.grid4 {\n  display: grid;\n  grid-template-columns: repeat(4, minmax(0, 1fr));\n  gap: 14px;\n  margin-bottom: 14px;\n}\n.grid3 {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 14px;\n  margin-bottom: 14px;\n}\n.grid2b {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 14px;\n}\n\n.field {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  min-width: 0;\n}\n.label {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--dylo-text);\n}\n.req {\n  color: var(--dylo-orange);\n  font-weight: 700;\n}\n\n/* Checkboxes */\n.checks {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  margin-top: 4px;\n}\n.checkRow {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  font-size: 13.5px;\n  color: var(--dylo-ink);\n  cursor: pointer;\n}\n.checkNative {\n  position: absolute;\n  opacity: 0;\n  width: 0;\n  height: 0;\n}\n.checkBox {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 18px;\n  height: 18px;\n  flex-shrink: 0;\n  border-radius: 5px;\n  border: 1.5px solid var(--dylo-field-border);\n  color: #fff;\n  transition: background 0.14s ease, border-color 0.14s ease;\n}\n.checkOn {\n  background: var(--dylo-teal-700);\n  border-color: var(--dylo-teal-700);\n}\n\n.alert {\n  margin-top: 16px;\n  padding: 11px 16px;\n  border-radius: 12px;\n  border: 1px solid color-mix(in srgb, var(--dylo-danger) 45%, transparent);\n  background: color-mix(in srgb, var(--dylo-danger) 10%, transparent);\n  color: var(--dylo-danger);\n  font-size: 13px;\n}\n.savedMsg {\n  margin-top: 16px;\n  padding: 11px 16px;\n  border-radius: 12px;\n  border: 1px solid color-mix(in srgb, #2aad27 45%, transparent);\n  background: color-mix(in srgb, #2aad27 10%, transparent);\n  color: #2aad27;\n  font-size: 13px;\n  font-weight: 600;\n}\n\n.actions {\n  display: flex;\n  gap: 12px;\n  margin-top: 20px;\n}\n.submitBtn {\n  background: var(--dylo-orange) !important;\n  border: none !important;\n}\n.submitBtn:hover:not(:disabled) {\n  background: var(--dylo-orange-hover) !important;\n}\n.deleteBtn {\n  flex-shrink: 0;\n  border: 1px solid color-mix(in srgb, var(--dylo-danger) 45%, transparent) !important;\n  color: var(--dylo-danger) !important;\n  background: transparent !important;\n}\n.deleteBtn:hover {\n  background: color-mix(in srgb, var(--dylo-danger) 12%, transparent) !important;\n}\n.deleteConfirm {\n  background: var(--dylo-danger) !important;\n  border: none !important;\n}\n.confirmText {\n  font-size: 13.5px;\n  color: var(--dylo-text);\n  line-height: 1.5;\n  margin: 0;\n}\n.confirmText b {\n  color: var(--dylo-ink);\n}\n\n/* Skeleton */\n.skTitle {\n  margin-bottom: 18px !important;\n}\n.skRounded {\n  border-radius: 10px !important;\n}\n\n@media (max-width: 1000px) {\n  .grid4 {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n}\n@media (max-width: 560px) {\n  /* `minmax(0, 1fr)` y no `1fr` (26-oct-2026): con `1fr` la columna no baja del ancho mínimo de un campo, que en el\n     iPhone es más ancho que en Chromium, y la forma se salía de la tarjeta (lo que le pasaba al login). */\n  .grid3,\n  .grid4,\n  .grid2b,\n  .schedulesRow {\n    grid-template-columns: minmax(0, 1fr);\n  }\n  /* Con una sola columna, `span 2` creaba una segunda de sobra y los campos quedaban más angostos que el recuadro de\n     horarios (21-oct-2026). */\n  .schedulesGroup {\n    grid-column: 1 / -1;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"page": `DeliveryForm_page__SFeNO`,
	"cardTitle": `DeliveryForm_cardTitle__RpQMf`,
	"fieldsGrid": `DeliveryForm_fieldsGrid__xSx-s`,
	"schedulesGroup": `DeliveryForm_schedulesGroup__qQsIl`,
	"groupLabel": `DeliveryForm_groupLabel__8mmr3`,
	"schedulesRow": `DeliveryForm_schedulesRow__CC9jv`,
	"checksGrid": `DeliveryForm_checksGrid__2K081`,
	"grid4": `DeliveryForm_grid4__CeQ2s`,
	"grid3": `DeliveryForm_grid3__AEQkh`,
	"grid2b": `DeliveryForm_grid2b__GaBuS`,
	"field": `DeliveryForm_field__dthiS`,
	"label": `DeliveryForm_label__X8vS2`,
	"req": `DeliveryForm_req__UMT6F`,
	"checks": `DeliveryForm_checks__-LCSj`,
	"checkRow": `DeliveryForm_checkRow__tcGFB`,
	"checkNative": `DeliveryForm_checkNative__Mxj8A`,
	"checkBox": `DeliveryForm_checkBox__CriYS`,
	"checkOn": `DeliveryForm_checkOn__T7VWi`,
	"alert": `DeliveryForm_alert__dydTa`,
	"savedMsg": `DeliveryForm_savedMsg__Zbpc9`,
	"actions": `DeliveryForm_actions__-GP7T`,
	"submitBtn": `DeliveryForm_submitBtn__ttMsP`,
	"deleteBtn": `DeliveryForm_deleteBtn__26I7y`,
	"deleteConfirm": `DeliveryForm_deleteConfirm__ltxap`,
	"confirmText": `DeliveryForm_confirmText__-e1he`,
	"skTitle": `DeliveryForm_skTitle__zHnnq`,
	"skRounded": `DeliveryForm_skRounded__q+P9i`
};
export default ___CSS_LOADER_EXPORT___;
